import {createContext} from 'react'

const CatTipoProductoContext = createContext()

export default CatTipoProductoContext